import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { request } from "../../helper/APIUtils";
import Alert from "react-s-alert";

const SendFileModal = ({ show, toggleModal, selected }) => {
    const [files, setFiles] = useState([]);
    const [uploading, setUploading] = useState(false);

    const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];

    const handleFileChange = (event) => {
        const newFiles = Array.from(event.target.files);

        const validFiles = newFiles.filter(file => allowedTypes.includes(file.type));

        if (validFiles.length !== newFiles.length) {
            Alert.error("Sadece PDF ve resim dosyaları yükleyebilirsiniz!");
        }

        setFiles((prevFiles) => [...prevFiles, ...validFiles]);
    };

    const removeFile = (index) => {
        setFiles(files.filter((_, i) => i !== index));
    };

    const handleUpload = async () => {
        if (files.length === 0) {
            Alert.error("Lütfen en az bir dosya seçiniz.");
            return;
        }

        setUploading(true);
        const formData = new FormData();
        files.forEach((file) => {
            formData.append("files", file);
        });

        formData.append("recordId", selected.recordId);
        formData.append("vknTckn", selected.vknTckn);

        try {
            await request({
                url: "https://crm.kolaysoft.com.tr/api/dealer/upload-payment-file",
                method: "POST",
                data: formData,
                headers: { "Content-Type": "multipart/form-data" },
            });

            Alert.success("Dosyalar başarıyla yüklendi.");
            setFiles([]);
            setTimeout(() => toggleModal(false), 1000);
        } catch (error) {
            Alert.error("Dosya yükleme işlemi başarısız oldu.");
        } finally {
            setUploading(false);
        }
    };

    return (
        <Modal isOpen={show} toggle={() => toggleModal(false)}>
            <ModalHeader toggle={() => toggleModal(false)}>Dosya Gönder</ModalHeader>
            <ModalBody>
                <input
                    type="file"
                    multiple
                    accept=".pdf, .jpg, .jpeg, .png"
                    onChange={handleFileChange}
                />
                {files.length > 0 && (
                    <ul style={{ marginTop: "10px" }}>
                        {files.map((file, index) => (
                            <li key={index} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "5px" }}>
                                {file.name}
                                <button
                                    onClick={() => removeFile(index)}
                                    style={{ background: "red", color: "white", border: "none", padding: "5px", cursor: "pointer", borderRadius: "5px" }}
                                >
                                    Sil
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={() => toggleModal(false)}>
                    Kapat
                </Button>
                <Button color="success" onClick={handleUpload} disabled={uploading}>
                    {uploading ? "Yükleniyor..." : "Gönder"}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default SendFileModal;
